// extracted by mini-css-extract-plugin
export default {"load":"Form_load__Tv09H"};